// extracted by css-extract-rspack-plugin
export default {"negative-margin":"marketplace-navigation-module__negative-margin__jlSoQ"};